import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Input from "./Input";
import { handleClick } from "./Alert";
import styles from "../NotesPage.module.scss";
import { PostNotes, getNotesData } from "service/NotesService";
import Notification from "utils/Notifications";
import { Button } from "components";
import ModalWindow from "hooks/ModalWindow/ModalWindow";


const Content = ({ setNotes }) => {
  const { t } = useTranslation('common');
  const [openModal, setOpenModal] = useState(false);
  const [body, setBody] = useState("");
  const [notesdata, setData] = useState([]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!body) {
      setNotify({
        isOpen: true,
        message: t('notes.fill_all_fields'),
        type: "error",
      });

    }
    else{
      const formData = new FormData();
    formData.append('body', body);


    let noteinfo = await PostNotes(formData);
    const iddata = noteinfo.data.id
    const createdAtdata = noteinfo.data.createdAt
    const note = { id: iddata, body, archived: false, createdAt: createdAtdata};

    setNotes((prevNotes) => [...prevNotes, note]);

    setBody("");
    setOpenModal(false)
    setNotify({
      isOpen: true,
      message: t('notes.note_created'),
      type: "success",
      sound: "success"
    });
    }

  };
  const handleEmojiSelect = (emoji) => {
    setBody(body + emoji);
  };
  return (
    <div className={styles["note-input"]}>
         <button
                  onClick={() => setOpenModal(true)}
                >
                  {t('notes.create_note')}
                </button>

      <ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalText={t('notes.new_note')}
      >
        <>
        <div className={styles["note-input"]}>

      <form onSubmit={handleSubmit} className="unv-form">


        <Input

          value={body}
          onChange={setBody}
          name="body"
          type="textarea"
          placeholder={t('notes.note_placeholder')}
        />


        <button
          type="submit"
          className={`${styles["create-btn"]} unv-btn unv-btn--primary`}

        >
          {t('notes.create')}
        </button>
      </form>
</div>
<br></br>
          <Button
            onClick={() => setOpenModal(false)}
            className={styles.btn_pin_close}
          >
            {" "}
            {t('notes.close')}
          </Button>
        </>
      </ModalWindow>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};

export default Content;
